/**
 * Normalize GET /strategy/:id/validate response so the UI never treats
 * HTTP errors or malformed JSON as "you don't own these orders".
 *
 * @param {Response} validationRes
 * @param {object} rawBody - parsed JSON or {}
 * @returns {{ valid: boolean, insufficientOrders: Array, fetchError?: boolean, errorMessage?: string }}
 */
export function normalizeStrategyValidationResponse(validationRes, rawBody) {
  if (!validationRes.ok) {
    const msg =
      rawBody && typeof rawBody.error === 'string'
        ? rawBody.error
        : `Request failed (${validationRes.status})`;
    return {
      valid: false,
      insufficientOrders: [],
      fetchError: true,
      errorMessage: msg,
    };
  }
  if (!rawBody || typeof rawBody.valid !== 'boolean') {
    return {
      valid: false,
      insufficientOrders: [],
      fetchError: true,
      errorMessage: 'Invalid response from server when verifying order ownership.',
    };
  }
  return {
    valid: rawBody.valid,
    insufficientOrders: Array.isArray(rawBody.insufficientOrders) ? rawBody.insufficientOrders : [],
  };
}
